import React, { useState } from 'react';
import { navigate } from "gatsby";

import { useLocalStorageState } from '../../utils/useLocalStorageState';
import { LanguageSlug } from '../../enums/languageSlug.enum';
import { LocalStorageKeys } from '@lerna-monorepo/common/enums/localStorageKeys.enum';

import { Input, SearchIcon, InputContainer, ClearIcon, Form } from './searchBox.styled';
import { SearchBoxData } from "./searchBox.types";
import Search from './images/search.icon.svg';
import Cross from './images/cross.svg';

export const SearchBox: React.FC<SearchBoxData> = ({ currentLanguage, onSubmit, placeholder }: SearchBoxData) => {
  const [query, setQuery] = useLocalStorageState(LocalStorageKeys.Search);
  const [searchPhrase, setSearchPhrase] = useState('');
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchPhrase(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent<HTMLElement>) => {
    if (!searchPhrase) return;
    e.preventDefault();
    setQuery({ value: searchPhrase, language: currentLanguage });
    setSearchPhrase('');
    const prefix = currentLanguage === LanguageSlug.Pl ? '/' : `/${currentLanguage}/`;
    const phrase = currentLanguage === LanguageSlug.Pl ? '' : `-${currentLanguage}`;
    //toDo translation
    navigate(`${prefix}wyszukiwarka${phrase}`);
    onSubmit && onSubmit();
  };

  const clearInput = () => {
    if (searchPhrase) {
      setSearchPhrase('');
      setQuery({ value: "", language: currentLanguage });
    };
  };

  return (
    <Form onSubmit={handleSubmit}>
      <InputContainer>
        <SearchIcon src={Search} alt="search" />
        <Input 
          value={searchPhrase} 
          onChange={handleChange}  
          placeholder={placeholder} 
        />
        <ClearIcon src={Cross} query={query.value} onClick={clearInput} />
      </InputContainer>
    </Form>
  );
};
